export default function isClassComponent(Component) {
    return Component.prototype && typeof Component.prototype.render === 'function';
}
